import { Modal } from '@chronosphereio/chrono-ui';

interface DiscardChangesConfirmationDialogProps {
  description: string;
  isOpen: boolean;
  onCancel: () => void;
  onDiscardChanges: () => void;
}

export const DiscardChangesConfirmationDialog = (props: DiscardChangesConfirmationDialogProps) => {
  const { description, isOpen, onCancel, onDiscardChanges } = props;

  return (
    <Modal
      open={isOpen}
      title="Discard changes"
      onClose={onCancel}
      onPrimaryButtonClick={onDiscardChanges}
      primaryButtonText="Discard changes"
      size="small"
    >
      {description}
    </Modal>
  );
};
